import { dataLayerConfig } from '@aspendental/shared-components-web';
import { Box, Skeleton, Stack } from '@mui/material';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import ScheduleQuestion from '@src/components/ScheduleQuestion';
import { HydraState } from '@src/constants';
import { useAppStore, usePatientInformationStore, useStepManagerStore } from '@src/store';
import useAppointmentInformationStore from '@src/store/appointment-information.store';
import useScheduleQuestionsStore from '@src/store/schedule-questions.store';
import { handlePageLeave } from '@src/utils/handle-page-leave';
export default function QuestionnaireStep() {
  const {
    questionsAnswers,
    questions,
    unansweredQuestions,
    loadingQuestions
  } = useScheduleQuestionsStore(store => store);
  const {
    leadId
  } = usePatientInformationStore(store => store);
  const {
    presetCenterID,
    presetCenterName
  } = useAppointmentInformationStore();
  const {
    enableHydraCalls
  } = useAppStore(store => store);
  const {
    setStepOnePtc
  } = useStepManagerStore();
  const {
    locale
  } = useRouter();
  useEffect(() => {
    dataLayerConfig({
      event: 'scheduleform_step1'
    });
    if (presetCenterID) {
      dataLayerConfig({
        event: 'appointment_step',
        step_name: 'start_about_you',
        lead_id: leadId,
        lead_tier: null,
        lead_segment: null,
        website_selected_center_name: presetCenterName,
        website_selected_center_id: presetCenterID,
        language_preference: locale ?? 'en-US',
        hydra_status: enableHydraCalls ? HydraState.ON : HydraState.OFF
      });
    } else {
      const gaTimeout = setTimeout(() => {
        dataLayerConfig({
          event: 'appointment_step',
          step_name: 'start_about_you',
          lead_id: leadId,
          lead_tier: null,
          lead_segment: null,
          website_selected_center_name: null,
          website_selected_center_id: null,
          language_preference: locale ?? 'en-US',
          hydra_status: enableHydraCalls ? HydraState.ON : HydraState.OFF
        });
      }, 3000);
      return () => clearTimeout(gaTimeout);
    }
  }, [enableHydraCalls, leadId, locale, presetCenterID, presetCenterName]);
  useEffect(() => {
    setStepOnePtc(false);
  }, [setStepOnePtc]);
  useEffect(() => {
    document.addEventListener('click', handlePageLeave, true);
    return () => {
      document.removeEventListener('click', handlePageLeave, true);
    };
  }, [questionsAnswers]);
  useEffect(() => {
    if (unansweredQuestions.length) {
      dataLayerConfig({
        event: 'scheduleform_step1_questionsnotcompleted'
      });
    }
  }, [unansweredQuestions]);
  return loadingQuestions ? <Stack spacing={2} data-sentry-element="Stack" data-sentry-component="QuestionnaireStep" data-sentry-source-file="QuestionnaireStep.tsx">
			<Skeleton animation="wave" variant="rounded" width="100%" height={100} data-sentry-element="Skeleton" data-sentry-source-file="QuestionnaireStep.tsx" />
			<Skeleton animation="wave" variant="rounded" width="100%" height={100} data-sentry-element="Skeleton" data-sentry-source-file="QuestionnaireStep.tsx" />
			<Skeleton animation="wave" variant="rounded" width="100%" height={100} data-sentry-element="Skeleton" data-sentry-source-file="QuestionnaireStep.tsx" />
			<Box sx={{
      width: '100%',
      height: '300px'
    }} data-sentry-element="Box" data-sentry-source-file="QuestionnaireStep.tsx" />
		</Stack> : <>
            <Stack direction="column" spacing={2.5} pt={2.5} gap={{
      md: 2
    }} data-sentry-element="Stack" data-sentry-source-file="QuestionnaireStep.tsx">
                {(questions ?? []).map((question, index) => <ScheduleQuestion key={`schedule-question-${index}`} unanswered={unansweredQuestions?.find(q => q.short_name === question.short_name)} {...question} data-test-id={`schedule-question-${index}`} />)}
            </Stack>
        </>;
}